// extracted by mini-css-extract-plugin
module.exports = {"search":"JlySlvdV","searchText":"RRe2Mzyx"};